<template>
    <div>
        <div>
            <div class="store-body">
                <b-row>
                    <b-col md="3">
                        <div class="bg-white p-3 mb-4 d-flex align-items-center justify-content-between rounded merchant-code-container">
                            <h3 class="mb-0">Merchant App ID</h3>
                            <span :class="['merchant-code', { 'border border-warning rounded px-3 py-1 merchant-code-rounded text-warning': !merchantCode, 'text-bold text-primary': merchantCode }]">{{ merchantCode ? merchantCode : 'Processing' }}</span>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="align-items-center">
                    <b-col>
                        <div class="store-content">
                            <div class="mb-4">
                                <b-row>
                                    <b-col sm="7" md="4">
                                        <div class="filter-wrapper">
                                            <b-input-group prepend=" ">
                                                <b-form-input placeholder="Search" v-model="search"></b-form-input>
                                                <b-dropdown text="Advanced" variant="primary" slot="append">
                                                    <b-dropdown-item v-for="(filter,index) in filters" @click="searchFilter( filter )" :key="index">
                                                        {{ filter.label }}
                                                        <template v-if="filter.key === searchBy">
                                                            <i class="ml-1">
                                                                <img width="15" height="15" src="@/assets/images/checked-symbol.svg" alt="" class="mr-1">
                                                            </i>
                                                        </template>
                                                    </b-dropdown-item>
                                                </b-dropdown>
                                            </b-input-group>
                                        </div>
                                    </b-col>
                                    <b-col sm="5" md="8" class="text-right">
                                        <b-button @click="newEmployee" variant="primary" class="new-button mr-2">
                                            + New Employee
                                        </b-button>
                                        <span class="d-inline-flex flex-column">
                                            <b-form-file
                                                v-model="importEmployeesCsv"
                                                hidden
                                                accept=".csv"
                                                ref="importEmployeesCsv">
                                            </b-form-file>
                                            <b-button
                                                id="bulk-import-employees"
                                                class="btn-tertiary btn-table-import-activation-key"
                                                @click="openBulkEmployeeImportModal">
                                                Import
                                            </b-button>
                                            <span class="csv-tooltip">
                                                CSV <downloadexcel
                                                    class   = "template-button"
                                                    :fields = "json_fields"
                                                    :data   = "json_data"
                                                    type    = "csv"
                                                    name = "employees_import_template.csv"
                                                >
                                                    (Template)
                                                </downloadexcel>
                                                <b-btn variant="ghost" v-b-popover.hover="'Import or export list of your employees in excel CSV format'" title="">
                                                    <i class="ic-tooltip" id="csv"></i>
                                                </b-btn>
                                            </span>
                                        </span>               
                                    </b-col>
                                </b-row>
                            </div>
                            <div class="mt-3">
                                <div class="data-container">
                                    <b-table :items="list"
                                             :show-empty="true"
                                             empty-text="Sorry no employee found"
                                             :fields="fields"
                                             :current-page="page"
                                    >
                                        <template slot="validate_password" slot-scope="data">
                                            <switches v-model="data.value" theme="custom" color="primary" type-bold="true"></switches>
                                        </template>
                                        <template slot="status" slot-scope="data">
                                            <switches v-model="data.value" theme="custom" color="primary" type-bold="true"></switches>
                                        </template>
                                        <template slot="action" slot-scope="data">
                                            <b-row no-gutters>
                                                <b-col class="text-center">
                                                    <i class="action-button" @click="updateEmployee(data.item)">
                                                        <img src="../../assets/images/achievement/action/edit.svg" alt="Edit Button">
                                                    </i>
                                                </b-col>
                                                <b-col class="text-center">
                                                    <i class="action-button" @click="confirmDelete(data.item)">
                                                        <img src="../../assets/images/achievement/action/delete.svg" alt="Delete Button">
                                                    </i>
                                                </b-col>
                                            </b-row>
                                        </template>
                                    </b-table>
                                </div>
                                <div class="table-toolbar-footer" v-if="list.length > 0">
                                    <span class="pagination-indicator"
                                        :class="{'text-left': isSetup}">
                                        {{ pagination.currentFirstItem }}-{{ pagination.currentLastItem }} of {{ pagination.maxPage }} page
                                    </span>
                                    <b-pagination align="left"
                                        hide-goto-end-buttons
                                        hide-ellipsis
                                        :limit="3"
                                        :total-rows="totalRows"
                                        :per-page="perPage"
                                        :value="page"
                                        @change="getList"
                                        class="custom-pagination-arrow-only mb-0 ml-2"
                                    >
                                    </b-pagination>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>

        <!-- EMPLOYEE MODAL -->
        <b-modal 
            v-model="showEmployeeModal"
            :title="employee.uuid === null ? 'Add New Employee' : 'Update Employee'"
            size="lg"
            @hide="onEmployeeModalHide"
        >
            <div id="employee-modal" class="modal-form">
                <b-form>
                    <b-row no-gutters
                        :class="{'text-left': isSetup}">
                        <b-col sm="12" md="3">
                            <h6 class="main-label">Employee Details</h6>
                        </b-col>
                        <b-col class="pl-5">
                            <b-form-group label="Full Name" class="secondary-label"
                                          :state="isValid('fullname')"
                                          :invalid-feedback="errors.fullname"
                            >
                                <b-form-input type="text" v-model="employee.fullname" required maxlength="50"></b-form-input>
                            </b-form-group>
                            <b-form-group label="Email Address" class="secondary-label"
                                          :state="isValid('email')"
                                          :invalid-feedback="errors.email"
                            >
                                <b-form-input type="email" v-model="employee.email" required maxlength="40"></b-form-input>
                            </b-form-group>
                            <b-form-group label="Mobile No." class="secondary-label"
                                          :state="isValid('mobile')"
                                          :invalid-feedback="errors.mobile"
                            >
                                <b-input-group prepend="+63">
                                    <b-form-input type="text" v-model="employee.mobile" required maxlength="10"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <BrandBranches 
                                v-if="showEmployeeModal"
                                @applyBrandsAndBranches="applyBrandsAndBranches"
                                errorKey="stores" 
                                :brandAndBranchUuids="employee.stores"
                            />
                            <div class="mb-2">
                                <span class="d-block mb-3 secondary-label">Status</span>
                                <switches
                                    v-model="employee.status"
                                    theme="custom"
                                    color="primary"
                                    type-bold="true"
                                    :class="{'mt-3': isSetup}">
                                </switches>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col>
                            <hr class="form-divider">
                        </b-col>
                    </b-row>
                    <b-row no-gutters
                        :class="{'text-left': isSetup}">
                        <b-col sm="12" md="3">
                            <h6 class="main-label">Password</h6>
                        </b-col>
                        <b-col class="pl-5">
                            <div class="mb-2">
                                <span class="d-block mb-3 secondary-label">Enable in App</span>
                                <switches
                                    v-model="employee.validate_password"
                                    theme="custom"
                                    color="primary"
                                    type-bold="true"
                                    :class="{'mt-3': isSetup}">
                                </switches>
                                <b-form-group label="Password" class="secondary-label"
                                              :state="isValid('password')"
                                              :invalid-feedback="errors.password"
                                >
                                    <b-form-input type="password" v-model="employee.password" maxlength="4" placeholder="Enter 4 digit pin."></b-form-input>
                                </b-form-group>
                                <b-form-group label="Password Confirmation" class="secondary-label"
                                              :state="isValid('password_confirmation')"
                                              :invalid-feedback="errors.password_confirmation"
                                >
                                    <b-form-input type="password" v-model="employee.password_confirmation" maxlength="4" placeholder="Enter 4 digit pin."></b-form-input>
                                </b-form-group>
                            </div>

                        </b-col>
                    </b-row>
                </b-form>
            </div>
            <div slot="modal-footer">
                <template v-if="loading">
                    <b-btn variant="ghost" class="mr-1 btn-cancel">
                        Loading
                    </b-btn>
                </template>
                <template v-else>
                    <b-btn
                        variant="ghost"
                        class="mr-1 btn-cancel"
                        @click="showEmployeeModal = false"
                    >
                        Cancel
                    </b-btn>
                    <b-btn
                        variant="primary"
                        class="ml-1"
                        @click="saveEmployee"
                    >
                        Submit
                    </b-btn>
                </template>
            </div>
        </b-modal>

        <!-- CONFIRM DELETE -->
        <b-modal ref="deleteModal" title="Confirm Delete">
        <p class="modal-main-message">Are you sure you want delete this item:</p>
        <h3 class="modal-secondary-message">
            {{ forDelete.name }}
        </h3>
        <div slot="modal-footer">
            <b-btn
                variant="ghost"
                class="mr-1 btn-cancel"
                @click="$refs.deleteModal.hide()"
            >
                Cancel
            </b-btn>
            <b-btn
                variant="primary"
                class="ml-1"
                @click="doDelete"
            >
                Yes, Delete
            </b-btn>
            <span class="modal-helper-message d-block mt-4">Caution: This cannot be undone.</span>
        </div>
    </b-modal>
    <BulkImportEmployees />
    </div>
</template>

<script>
import Switches from "vue-switches";
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import BrandBranches from "@/components/store/BrandBranches";
import downloadexcel from "vue-json-excel";
import BulkImportEmployees from "@/components/employees/BulkImportEmployeesModal";

export default {
    name: "EmployeeTabContent",
    props: ["isSetup"],
    data() {
        return {
            showEmployeeModal: false,
            timerSearch: null,
            forDelete: {},
            filters: [
                {
                    key: "all",
                    label: "All"
                },
                {
                    key: "employee_id",
                    label: "Employee Number"
                },
                {
                    key: "fullname",
                    label: "Fullname"
                },
                {
                    key: "email",
                    label: "Email Address"
                },
                {
                    key: "mobile",
                    label: "Mobile Number"
                }
            ],
            search: null,
            employee: {},
            employees: [],
            fields: [
                {
                    key: "employee_id",
                    label: "Employee Number"
                },
                {
                    key: "fullname",
                    label: "Full Name"
                },
                {
                    key: "email",
                    label: "Email Address"
                },
                {
                    key: "mobile",
                    label: "Mobile No."
                },
                {
                    key: "last_login",
                    label: "Last Login",
                    formatter(value) {
                        if (value === null) return null;
                        return moment(value, "YYYY-MM-DD HH:mm:ss").format(
                            "MMM D, YYYY hh:mm A"
                        );
                    }
                },
                {
                    key: "validate_password",
                    label: "Password"
                },
                {
                    key: "status",
                    label: "Status"
                },
                "action"
            ],
            perPage: 25,
            importEmployeesCsv: null,
            json_fields: {
                "Full Name": "full_name",
                "Mobile Number": "mobile_number",
                Email: "email",
                Password: "password"
            },
            json_data: [
                {
                    full_name: " ",
                    mobile_number: " ",
                    email: " ",
                    password: " "
                }
            ],
            payload: null,
        };
    },
    created() {
        this.$store.dispatch("employees/getList");
        this.$store.dispatch("branches/getBranches");
    },

    watch: {
        employeeCreated(value) {
            if (value) {
                if (this.isSegmentAnalyticsReady) {
                    window.analytics.track("Create Employee", this.payload);
                }

                this.$store.dispatch("employees/getList");
                this.showEmployeeModal = false;
            }
        },

        employeeDeleted(value) {
            if (value) {
                this.$store.dispatch("employees/getList");
                this.$refs.deleteModal.hide();
            }
        },

        employeeUpdated(value) {
            if (value) {
                if (this.isSegmentAnalyticsReady) {
                    window.analytics.track("Update Employee", this.payload);
                }

                this.$store.dispatch("employees/getList");
                this.showEmployeeModal = false;
            }
        },

        search() {
            let self = this;

            clearTimeout(this.timerSearch);
            this.timerSearch = setTimeout(() => {
                self.doSearch();
            }, 500);
        }
    },

    methods: {
        searchFilter(filter) {
            this.$store.commit("employees/searchBy", filter.key);
            this.doSearch();
        },

        getList(page) {
            if (this.$refs.success) this.$refs.success.hide();
            this.$store.dispatch("employees/getList", page);
        },

        doSearch() {
            this.$store.commit("employees/setSearch", this.search);
            this.$store.dispatch("employees/getList");
        },

        isValid(field) {
            return this.errors[field] ? false : true;
        },
        saveEmployee() {
            this.payload = {
                fullname: this.employee.fullname,
                email: this.employee.email,
                mobile: this.employee.mobile,
                validate_password: this.employee.validate_password,
                status: this.employee.status,
                password: this.employee.password,
                password_confirmation: this.employee.password_confirmation,
                stores: this.employee.stores,
                merchant_uuid: this.merchantUuid
            };

            if (!this.employee.uuid) {
                this.$store.dispatch("employees/create", this.payload);
            } else {
                this.payload.uuid = this.employee.uuid;
                this.$store.dispatch("employees/update", this.payload);
            }
        },
        newEmployee() {
            this.$store.commit("employees/reset");
            this.employee = {
                uuid: null,
                fullname: null,
                email: null,
                mobile: null,
                validate_password: true,
                status: true,
                password: null,
                password_confirmation: null,
                stores: []
            };
            this.showEmployeeModal = true;
        },
        updateEmployee(data) {
            this.$store.commit("employees/reset");
            this.employee = {
                uuid: data.uuid,
                fullname: data.fullname,
                email: data.email,
                mobile: data.mobile,
                validate_password: data.validate_password,
                status: data.status,
                password: null,
                password_confirmation: null,
                stores: data.stores
            };
            this.showEmployeeModal = true;
        },
        confirmDelete(data) {
            this.forDelete = {
                uuid: data.uuid,
                name: data.fullname
            };
            this.$refs.deleteModal.show();
        },
        doDelete() {
            this.$store.dispatch("employees/delete", this.forDelete.uuid);
        },
        applyBrandsAndBranches(brandAndBranches, isAllStores) {
            if (isAllStores) {
                this.employee.stores = this.branches.map(
                    ({ uuid, brand_uuid }) => ({
                        branch_uuid: uuid,
                        brand_uuid
                    })
                );
            } else
                this.employee.stores = JSON.parse(
                    JSON.stringify(brandAndBranches)
                );
        },
        onEmployeeModalHide() {
            this.employee.stores = [];
        },
        openBulkEmployeeImportModal() {
            this.$root.$emit("bv::show::modal", "bulk-import-employees-modal");
        }
    },

    computed: {
        ...mapState("employees", [
            "maxPage",
            "page",
            "list",
            "errors",
            "loading",
            "searchBy",
            "pagination"
        ]),

        ...mapState("employees", {
            employeeCreated: "created",
            employeeDeleted: "deleted",
            employeeUpdated: "updated"
        }),

        ...mapState("branches", {
            branches: "options"
        }),
        ...mapState("analytics", ["isSegmentAnalyticsReady"]),

        ...mapGetters("auth", ["merchantDetails", "merchantUuid"]),

        totalRows() {
            return this.perPage * this.maxPage;
        },

        merchantCode: {
            get() {
                return this.merchantDetails.code;
            },
            set(code) {
                return code;
            }
        }
    },

    components: {
        Switches,
        BrandBranches,
        downloadexcel,
        BulkImportEmployees
    }
};
</script>

<style lang="scss" scoped>
.merchant-code-container {
    box-shadow: 0 0 9px 0 #e7e7e7;
    h3 {
        font-family: MainFontRegular, sans-serif;
        font-size: 16px;
        color: #2a2a2a;
    }
    .merchant-code {
        &.text-bold {
            font-family: MainFontBold, sans-serif;
            font-weight: normal;
        }
        &.merchant-code-rounded {
            border-radius: 20px !important;
        }
    }
}
#employee-modal {
    width: 560px;
}
.csv-tooltip {
    display: inline-block;
    font-family: MainFontBold, sans-serif;
    font-size: 15px;
    color: #979797;
    margin-right: 10px;
}
#bulk-import-employees {
    width: 110px;
    height: 40px;
    border-radius: 40px;
    font-family: MainFontBold, sans-serif;
    font-size: 13px;
    font-weight: normal;
    text-indent: 25px;
    background: #ffffff url("~@/assets/images/actions/thick-import-grey.svg")
        no-repeat center left 15px / 19px;
    &.half-oval-right {
        border-radius: 40px 0 0 40px;
        border-right: solid 1px #fff;
    }
}
</style>
